import { ScheduledPostSettings } from 'api/clients/ScheduledPostsClient'
import { MediaObject } from 'types'

const goHighLevelContentValidator = (_content: string): string[] => {
  return []
}

const goHighLevelFileValidator = (_files: MediaObject[]): string[] => {
  return []
}

const goHighLevelVideosSizeValidator = (_files: MediaObject[]): string[] => {
  return []
}

const goHighLevelImageSizeValidator = (_files: MediaObject[]): string[] => {
  return []
}

const goHighLevelDurationValidator = (_files: MediaObject[]): string[] => {
  return []
}

const goHighLevelAspectRatioValidator = (_files: MediaObject[]): string[] => {
  return []
}

const goHighLevelFormatsValidator = (_files: MediaObject[]): string[] => {
  return []
}

const goHighLevelVideosValidator = (_files: MediaObject[]): string[] => {
  return []
}

const goHighLevelPostSettingsValidator = (_settings?: ScheduledPostSettings): string[] => {
  return []
}

const goHighLevelValidators = {
  validateContent: goHighLevelContentValidator,
  validateFiles: goHighLevelFileValidator,
  validateVideosSize: goHighLevelVideosSizeValidator,
  validateImagesSize: goHighLevelImageSizeValidator,
  validateVideosDuration: goHighLevelDurationValidator,
  validateVideosAspectRatio: goHighLevelAspectRatioValidator,
  validateVideosFormat: goHighLevelFormatsValidator,
  validateVideosCount: goHighLevelVideosValidator,
  validatePostSettings: goHighLevelPostSettingsValidator,
}

export default goHighLevelValidators
